import { useSetState } from 'ahooks'
import { observer, useLocalStore } from 'mobx-react-lite'
import React, { useMemo } from 'react'

import { NewEditForm } from '@/components'
import dictStore from '@/store/global/dictStore'

import config from './config.json'
import { getFormItems } from './const'
import useYiDong from './hooks/useYidong'
import './index.less'
/**
 * 动态切换表单元素
 * @param param0
 * @returns
 */
function DynamicsElement({ form, ...rest }: any) {
  const zidianStore = useLocalStore(() => dictStore)
  /**
   * @param name 输出value的字段名
   * @param typeItem 切换元素的下拉选择器
   * @param targetItems 切换后变化的表单元素列表，FormItem.name会匹配typeItem的字典值
   */
  const { name = 'column_value', typeItem, targetItems } = rest || {}
  const [{ type }, setState] = useSetState<{ type: string }>({
    type: typeItem?.formItemProps?.initialValue || ''
  })
  // 批量修改员工 - 定制
  useYiDong({ zidianStore, enable: true })
  // 切换元素类型
  const handleChange = (_type: string) => {
    console.log('切换元素类型:', _type)
    setState({ type: _type })
    // 如果传入onChange就执行
    typeItem?.elementProps?.onChange?.(_type)
    // form reset value
    form?.resetFields([name])
  }
  // 组装动态字段
  const formInfo = useMemo(() => {
    // 默认值 - 调试用
    const defaultItems = getFormItems({ name, onChange: handleChange })
    const items =
      typeItem && targetItems
        ? [typeItem, targetItems?.find((item: any) => item.name === type)]
        : defaultItems

    return [
      {
        form_list: getFormItems({
          name,
          typeItem: items[0],
          item: items[1],
          onChange: handleChange
        })
      }
    ]
  }, [type])
  console.log(formInfo, 'formInfo')
  return (
    <NewEditForm
      className='dynamics-element-wrap'
      formType='item'
      formInfo={formInfo}
      form={form}
    />
  )
}

// 调用方式
DynamicsElement.config = config

export default observer(DynamicsElement)
